import { httpClient } from '../network/httpclient/HttpClientFactory';
import { wrapHttpClient } from '../helper/HttpHelper';
import authHeader from './Header';

const save = param => httpClient.post(`/appdevice`, param, { headers: authHeader() }).then(res => res.data);

export default {
    save: wrapHttpClient(save)
};
